<template>
  <field-label :label="label" :required="required" :hide-required="hideRequired">
    <v-text-field
      :outlined="outlined"
      :dense="dense"
      :placeholder="computedPlaceholder"
      :counter="computedMaxLength"
      :rules="computedRules"
      :value="value"
      :type="type"
      :min="min"
      :max="max"
      :class="customClass"
      v-mask="mask"
      v-on="$listeners"
      v-bind="$attrs"
      hide-spin-buttons
      :hide-details="hideDetails"
      :disabled="disabled"
    />
  </field-label>
</template>

<script>
import { mask } from 'vue-the-mask'
import FieldLabel from './FieldLabel.vue'
export default {
  name: 'TextField',
  components: { FieldLabel },
  directives: {
    mask: {
      bind(el, binding, vnode, oldVnode) {
        if (binding.value) {
          mask(el, binding, vnode, oldVnode)
        }
      },
    },
  },
  computed: {
    computedMaxLength() {
      return this.maxLength > 0 && !this.hideMaxLength ? this.maxLength : undefined
    },
    computedPlaceholder() {
      return this.placeholder ?? this.label
    },
    computedRules() {
      const rules = []
      if (this.required) {
        rules.push(this.$validation.required())
      }
      if (this.computedMaxLength) {
        rules.push(this.$validation.maxChars(this.computedMaxLength))
      }
      if (this.type === 'number') {
        if (this.min || this.min === 0) {
          rules.push(this.$validation.minValue(this.min))
        }
        if (this.max || this.max === 0) {
          rules.push(this.$validation.maxValue(this.max))
        }
      }
      rules.push(...(this.rules ?? []))
      return rules
    },
  },
  props: {
    value: [String, Number],
    label: String,
    maxLength: {
      type: Number,
    },
    hideMaxLength: {
      type: Boolean,
      default: false,
    },
    rules: Array,
    required: Boolean,
    hideRequired: {
      type: Boolean,
      default: false,
    },
    mask: [Array, String],
    placeholder: String,
    type: {
      type: String,
      default: 'text',
    },
    min: Number,
    max: Number,
    customClass: {} || String,
    outlined: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    hideDetails: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
